import { ReviewTemplate } from './components/review-assessment-sections/review-assessment-sections.component'

export const COS_REVIEW_TEMPLATE: ReviewTemplate = {
   reviewType: 'COS',
   sections: [
      {
         id: 'section_job_description',
         revieweeTitle: 'Chief of Staff Job Description',
         reviewerTitle: '',
         questions: [
            {
               id: 'job_description_reviewed',
               type: 'checkbox',
               required: true,
               options: [
                  {
                     label: 'I have reviewed my current job description in Skyworld.',
                     value: 'reviewed_job_description',
                  },
               ],
               revieweeLabel:
                  'Please review your updated job description in Skyworld using the link below. The job description will open in a new browser tab. After reviewing it, return to this self-assessment (your original tab) and confirm that you’ve reviewed the job description by checking the box below.<span class="required-asterisk">&nbsp;*</span><p></p><p><a href="https://vetcor.skyworld.com/userfilesV3/files/Vetcor%20COS%20Job%20Description%202026(2).pdf" target="_blank">COS Job Description 2026 &nbsp;&nbsp;<i class="fa fa-external-link-alt"></i></a></p>',
               maxSelections: 1,
               labelIsHtml: true,
               reviewerLabel: '',
            },
         ],
      },

      // A. Engagement & Well-Being
      {
         id: 'section_a',
         revieweeTitle: 'Engagement & Well-Being',
         reviewerTitle: 'Engagement & Well-Being',
         questions: [
            {
               id: 'engagement_overall',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall engagement',
               revieweeOptions: [
                  { label: 'Highly engaged', value: 'highly_engaged' },
                  { label: 'Engaged', value: 'engaged' },
                  { label: 'Steady', value: 'steady' },
                  { label: 'Strained', value: 'strained' },
                  { label: 'At risk of burnout', value: 'at_risk_of_burnout' },
               ],
               reviewerLabel: 'Observed engagement of the COS',
               reviewerOptions: [
                  { label: 'Highly engaged', value: 'highly_engaged' },
                  { label: 'Engaged', value: 'engaged' },
                  { label: 'Steady', value: 'steady' },
                  { label: 'Strained', value: 'strained' },
                  { label: 'At risk of burnout', value: 'at_risk_of_burnout' },
               ],
            },
            {
               id: 'engagement_factors',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Workload/caseload', value: 'workload_caseload' },
                  { label: 'Leadership support', value: 'leadership_support' },
                  { label: 'DVM dynamics', value: 'dvm_dynamics' },
                  { label: 'Schedule/work-life balance', value: 'schedule_work_life_balance' },
                  { label: 'Admin burden', value: 'admin_burden' },
                  { label: 'Culture/team health', value: 'culture_team_health' },
               ],
               revieweeLabel: 'Top factors influencing how I feel (select up to 2)',
               reviewerLabel: 'Top observed contributors (select up to 2)',
               maxSelections: 2,
               hasOther: true,
            },
            {
               id: 'engagement_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional examples of how workload concerns have been communicated or supported this year)',
               reviewerLabel: 'Notes (optional – examples of how workload concerns have been communicated, supported, or addressed)',
            },
         ],
      },

      // B. Medical Leadership, Quality & Impact
      {
         id: 'section_b',
         revieweeTitle: 'Medical Leadership, Quality & Impact',
         reviewerTitle: 'Medical Leadership, Quality & Impact',
         questions: [
            {
               id: 'medical_leadership_effectiveness',
               type: 'radio',
               required: true,
               revieweeLabel: 'My effectiveness in medical leadership',
               revieweeOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Solid', value: 'solid' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
               reviewerLabel: 'Overall effectiveness in medical leadership',
               reviewerOptions: [
                  { label: 'Excellent', value: 'excellent' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Solid', value: 'solid' },
                  { label: 'Developing', value: 'developing' },
                  { label: 'Needs support', value: 'needs_support' },
               ],
            },
            {
               id: 'medical_strengths',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Medical quality oversight', value: 'medical_quality_oversight' },
                  { label: 'Complex case management', value: 'complex_case_management' },
                  { label: 'Mentoring/coaching DVMs', value: 'mentoring_coaching_dvms' },
                  { label: 'Establishing standards/protocols', value: 'standards_protocols' },
                  { label: 'Documentation & compliance standards', value: 'documentation_compliance' },
                  { label: 'Client communication/conflict', value: 'client_communication_conflict' },
                  { label: 'DVM accountability/performance conversations', value: 'dvm_accountability_conversations' },
                  { label: 'Medical & financial caseload review for doctor team', value: 'medical_financial_caseload_review' },
                  { label: 'Surgical/anesthesia leadership', value: 'surgical_anesthesia_leadership' },
                  { label: 'Understanding and using hospital KPIs/financial performance', value: 'kpis_financial_performance' },
               ],
               revieweeLabel: 'Select up to 2 areas where I am strongest',
               reviewerLabel: 'Select up to 2 observed strengths',
               maxSelections: 2,
               hasOther: true,
            },
            {
               id: 'medical_growth_areas',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Medical quality oversight', value: 'medical_quality_oversight' },
                  { label: 'Complex case management', value: 'complex_case_management' },
                  { label: 'Mentoring/coaching DVMs', value: 'mentoring_coaching_dvms' },
                  { label: 'Establishing standards/protocols', value: 'standards_protocols' },
                  { label: 'Documentation & compliance standards', value: 'documentation_compliance' },
                  { label: 'Client communication/conflict', value: 'client_communication_conflict' },
                  { label: 'DVM accountability/performance conversations', value: 'dvm_accountability_conversations' },
                  { label: 'Medical & financial caseload review for doctor team', value: 'medical_financial_caseload_review' },
                  { label: 'Surgical/anesthesia leadership', value: 'surgical_anesthesia_leadership' },
                  { label: 'Understanding and using hospital KPIs/financial performance', value: 'kpis_financial_performance' },
               ],
               revieweeLabel: 'Select up to 2 areas where I’d like to grow',
               reviewerLabel: 'Select up to 2 priority growth areas',
               maxSelections: 2,
               hasOther: true,
            },
            {
               id: 'medical_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional)',
               reviewerLabel: 'Notes (optional)',
            },
         ],
      },

      // C. Team & Leadership Partnerships
      {
         id: 'section_c',
         revieweeTitle: 'Team & Leadership Partnerships',
         reviewerTitle: 'Team & Leadership Partnerships',
         questions: [
            {
               id: 'collaboration_hm',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall collaboration with Hospital Manager',
               revieweeOptions: [
                  { label: 'Very strong', value: 'very_strong' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Generally good', value: 'generally_good' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Challenging', value: 'challenging' },
               ],
               reviewerLabel: 'Observed collaboration with Hospital Manager',
               reviewerOptions: [
                  { label: 'Very strong', value: 'very_strong' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Generally good', value: 'generally_good' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Challenging', value: 'challenging' },
               ],
            },
            {
               id: 'collaboration_hm_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust/connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve partnership (select up to 2)',
               reviewerLabel: 'What would most improve partnership (select up to 2)',
               maxSelections: 2,
               hasOther: true,
            },

            {
               id: 'collaboration_cosa',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall collaboration with COSA',
               revieweeOptions: [
                  { label: 'Very strong', value: 'very_strong' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Generally good', value: 'generally_good' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Challenging', value: 'challenging' },
               ],
               reviewerLabel: 'Observed collaboration with COSA',
               reviewerOptions: [
                  { label: 'Very strong', value: 'very_strong' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Generally good', value: 'generally_good' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Challenging', value: 'challenging' },
               ],
            },
            {
               id: 'collaboration_cosa_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust/connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve partnership (select up to 2)',
               reviewerLabel: 'What would most improve partnership (select up to 2)',
               maxSelections: 2,
               hasOther: true,
            },

            {
               id: 'collaboration_rm',
               type: 'radio',
               required: true,
               revieweeLabel: 'Overall collaboration with Regional Manager',
               revieweeOptions: [
                  { label: 'Very strong', value: 'very_strong' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Generally good', value: 'generally_good' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Challenging', value: 'challenging' },
               ],
               reviewerLabel: 'Observed collaboration with Regional Manager',
               reviewerOptions: [
                  { label: 'Very strong', value: 'very_strong' },
                  { label: 'Strong', value: 'strong' },
                  { label: 'Generally good', value: 'generally_good' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Challenging', value: 'challenging' },
               ],
            },
            {
               id: 'collaboration_rm_improve',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Clear expectations', value: 'clear_expectations' },
                  { label: 'Communication alignment', value: 'communication_alignment' },
                  { label: 'Staffing decisions', value: 'staffing_decisions' },
                  { label: 'Escalation support', value: 'escalation_support' },
                  { label: 'Trust/connection', value: 'trust_connection' },
               ],
               revieweeLabel: 'What would most improve partnership (select up to 2)',
               reviewerLabel: 'What would most improve partnership (select up to 2)',
               maxSelections: 2,
               hasOther: true,
            },

            {
               id: 'partnership_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional)',
               reviewerLabel: 'Notes (optional)',
            },
         ],
      },

      // D. Culture, Professional Presence & SOP Alignment
      {
         id: 'section_d',
         revieweeTitle: 'Culture, Professional Presence & SOP Alignment',
         reviewerTitle: 'Culture, Professional Presence & SOP Alignment',
         questions: [
            {
               id: 'culture_influence',
               type: 'radio',
               required: true,
               revieweeLabel: 'My influence on hospital culture',
               revieweeOptions: [
                  { label: 'Positive role model', value: 'positive_role_model' },
                  { label: 'Strong contributor', value: 'strong_contributor' },
                  { label: 'Generally positive', value: 'generally_positive' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Needs focus', value: 'needs_focus' },
               ],
               reviewerLabel: 'Impact on hospital culture and leadership presence',
               reviewerOptions: [
                  { label: 'Positive role model', value: 'positive_role_model' },
                  { label: 'Strong contributor', value: 'strong_contributor' },
                  { label: 'Generally positive', value: 'generally_positive' },
                  { label: 'Inconsistent', value: 'inconsistent' },
                  { label: 'Needs focus', value: 'needs_focus' },
               ],
            },
            {
               id: 'sop_consistency',
               type: 'radio',
               required: true,
               revieweeLabel: 'Consistency with SOPs and expectations',
               revieweeOptions: [
                  { label: 'Role model', value: 'role_model' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Mostly consistent', value: 'mostly_consistent' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
               reviewerLabel: 'Consistency with SOPs and role expectations',
               reviewerOptions: [
                  { label: 'Role model', value: 'role_model' },
                  { label: 'Consistent', value: 'consistent' },
                  { label: 'Mostly consistent', value: 'mostly_consistent' },
                  { label: 'Needs improvement', value: 'needs_improvement' },
               ],
            },
            {
               id: 'intentionality_area',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'One area I want to be more intentional about this year',
               reviewerLabel: 'One area for increased intentionality this year',
            },
         ],
      },

      // E. Sustainability & Workload
      {
         id: 'section_e',
         revieweeTitle: 'Sustainability & Workload',
         reviewerTitle: 'Sustainability & Workload',
         questions: [
            {
               id: 'workload_sustainability',
               type: 'radio',
               required: true,
               revieweeLabel: 'My current workload feels',
               revieweeOptions: [
                  { label: 'Sustainable', value: 'sustainable' },
                  { label: 'Mostly manageable', value: 'mostly_manageable' },
                  { label: 'Borderline', value: 'borderline' },
                  { label: 'Unsustainable', value: 'unsustainable' },
               ],
               reviewerLabel: 'Sustainability of the COS’s current workload',
               reviewerOptions: [
                  { label: 'Sustainable', value: 'sustainable' },
                  { label: 'Mostly manageable', value: 'mostly_manageable' },
                  { label: 'Borderline', value: 'borderline' },
                  { label: 'Unsustainable', value: 'unsustainable' },
               ],
            },
            {
               id: 'workload_contributors',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Caseload', value: 'caseload' },
                  { label: 'Staffing gaps', value: 'staffing_gaps' },
                  { label: 'Admin expectations', value: 'admin_expectations' },
                  { label: 'Schedule', value: 'schedule' },
                  { label: 'Emotional load', value: 'emotional_load' },
               ],
               revieweeLabel: 'Biggest contributors (select up to 2)',
               reviewerLabel: 'Primary contributors (select up to 2)',
               maxSelections: 2,
               hasOther: true,
            },
            {
               id: 'workload_notes',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Notes (optional - where delegation, prioritization, or role balance feels most challenging)',
               reviewerLabel: 'Notes (optional)',
            },
         ],
      },

      // F. Reflection & Forward Focus
      {
         id: 'section_f',
         revieweeTitle: 'Reflection & Forward Focus',
         reviewerTitle: 'Reflection & Forward Focus',
         questions: [
            {
               id: 'priorities_next_year',
               type: 'checkbox',
               required: true,
               options: [
                  { label: 'Medical quality', value: 'medical_quality' },
                  { label: 'DVM development', value: 'dvm_development' },
                  { label: 'Culture/team health', value: 'culture_team_health' },
                  { label: 'Partnership alignment', value: 'partnership_alignment' },
                  { label: 'Personal sustainability', value: 'personal_sustainability' },
                  { label: 'Client experience', value: 'client_experience' },
                  { label: 'Hospital performance/efficiency', value: 'hospital_performance_efficiency' },
               ],
               revieweeLabel: 'Top priorities for the coming year (select up to 2)',
               reviewerLabel: 'Top priorities for this COS in the coming year (select up to 2)',
               maxSelections: 2,
               hasOther: true,
            },
            {
               id: 'accomplishment',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Accomplishment I’m most proud of this year',
               reviewerLabel: 'Accomplishment most worth recognizing this year',
            },
            {
               id: 'development_goals',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel:
                  'Additional professional or clinical development goals this year (e.g., new skills, certifications, clinical interests)',
               reviewerLabel: 'Key professional, clinical, or leadership development goals for the coming year',
            },
            {
               id: 'anything_else_support',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Anything I want my COSA/RM/HM to understand about my experience',
               reviewerLabel: 'Anything else that would support this COS’s success',
            },
         ],
      },
   ],
}
